import Router from "next/router";

export default function redirect(ctx, url) {
  if (!url) {
    throw new Error("url required to redirect");
  }
  if (!process.browser && !ctx) {
    throw new Error("ctx required to redirect");
  }
  if (ctx?.res) {
    ctx.res.writeHead(302, { Location: url });
    ctx.res.end();
  } else if (url[0] === "/" && url[1] !== "/") {
    void Router.push(url);
  } else {
    window.location = url;
  }
}
